import * as React from 'react';
import * as classnames from 'classnames';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { readReviewsTheme } from '../theme/default-theme';
import { ContentSpacing } from '@estee/elc-base-theme';
import { READ_REVIEW_LABEL, WRITE_REVIEW_LABEL } from '../constants/DataTestIds';

export interface IReadReviews {
    className?: string;
    readReviewsLabel?: string;
    reviewsNumber: number;
    firstToWriteReviewLabel?: string;
    onReadReviewsClick?(): void;
    onWriteReviewsClick?(): void;
    hideReviewsLabel?: boolean;
}

const ReadReviewsWrapper = styled.span`
    display: inline-block;
    vertical-align: middle;
    padding: 2px ${ContentSpacing.space12};
    margin: 0 ${ContentSpacing.space8};
    border-left-width: 1px;
    border-left-style: solid;
    ${readReviewsTheme};
    [dir='rtl'] & {
        border-right: 1px solid;
        border-left: none;
    }
`;

const ReadReviewLabel = styled.span`
    display: inline-block;
    padding: 2px 4px;
`;

const WriteReviewLabel = styled.span`
    display: inline-block;
`;

const reviewsClassNames = classnames('elc-product-reviews-link', 'js-product-reviews-link');
const readReviewsClassName = classnames(
    'elc-read-reviews-link',
    'js-read-reviews-link',
    reviewsClassNames
);
const writeReviewClassName = classnames(
    'elc-write-first-review',
    'js-write-first-review',
    reviewsClassNames
);

export const ReadReviews = observer((props: IReadReviews) => {
    const {
        reviewsNumber,
        firstToWriteReviewLabel,
        readReviewsLabel,
        className,
        hideReviewsLabel
    } = props;
    const classNames = classnames('elc-read-reviews', 'js-read-reviews', className);

    return (
        <ReadReviewsWrapper className={classNames}>
            {!!reviewsNumber && !hideReviewsLabel && (
                <ReadReviewLabel
                    className={readReviewsClassName}
                    aria-label={readReviewsLabel}
                    data-test-id={READ_REVIEW_LABEL}
                >
                    {readReviewsLabel}
                </ReadReviewLabel>
            )}
            {!reviewsNumber && (
                <WriteReviewLabel
                    className={writeReviewClassName}
                    data-test-id={WRITE_REVIEW_LABEL}
                >
                    {firstToWriteReviewLabel}
                </WriteReviewLabel>
            )}
        </ReadReviewsWrapper>
    );
});
